var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2652 49L11.2185 49.0467L11.1695 49H6.98117C6.36707 48.9994 5.77833 48.755 5.34431 48.3205C4.9103 47.8861 4.6665 47.2971 4.6665 46.683V9.317C4.67077 8.70422 4.91594 8.11771 5.34903 7.68417C5.78213 7.25064 6.36839 7.00489 6.98117 7H49.0185C50.2972 7 51.3332 8.03833 51.3332 9.317V46.683C51.3289 47.2958 51.0837 47.8823 50.6506 48.3158C50.2175 48.7494 49.6313 48.9951 49.0185 49H11.2652ZM46.6665 35V11.6667H9.33317V44.3333L32.6665 21L46.6665 35ZM46.6665 41.5987L32.6665 27.5987L15.9318 44.3333H46.6665V41.5987ZM18.6665 25.6667C17.4288 25.6667 16.2418 25.175 15.3667 24.2998C14.4915 23.4247 13.9998 22.2377 13.9998 21C13.9998 19.7623 14.4915 18.5753 15.3667 17.7002C16.2418 16.825 17.4288 16.3333 18.6665 16.3333C19.9042 16.3333 21.0912 16.825 21.9663 17.7002C22.8415 18.5753 23.3332 19.7623 23.3332 21C23.3332 22.2377 22.8415 23.4247 21.9663 24.2998C21.0912 25.175 19.9042 25.6667 18.6665 25.6667Z",
    fill: "#DEDEDE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPic);
export default __webpack_public_path__ + "static/media/noPic.7cb2a797196947ff5a2a75b402f49e87.svg";
export { ForwardRef as ReactComponent };